import 'normalize.css'
import '@/styles/app.scss'
import 'intersection-observer'
import '@tenthree/udn-election2020-shared-lib/dist/udn-election2020-shared-lib.min.css'
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import Election2020 from '@tenthree/udn-election2020-shared-lib'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

Vue.use(VueScrollTo)
Vue.use(Election2020)

Vue.bus = Vue.prototype.$bus = new Vue()

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
